import { ErrorMessage, Field, FormikProps } from "formik";
import { Button, Label, useColorMode } from "theme-ui";
import theme from "../../../../theme";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withFormikValidation } from "./enhancer/AddEditDepartmentTypeMasterDataEnhancer";
import { createDepartmentTypes, getAllDepartmentTypes, getDepartmentDataById, updateDepartmentTypes } from "../../../../store/actions/departmentAction";

const AddEditDepartmentMasterData: React.FC<FormikProps<any>> = ({
    values,
    errors,
    touched,
    handleSubmit,
    setValues,
    isValid,
    isSubmitting,
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const hasSubmittedRef = useRef(false);
    const { departmentTypeId } = useParams();
    const isEditMode = Boolean(departmentTypeId);

    const { selected, loading, error } = useSelector(
        (state: any) => state.departmentTypes
    );
    const [colorMode] = useColorMode();


    /* ===================== FETCH DATA (EDIT MODE ONLY) ===================== */
    useEffect(() => {
        if (isEditMode && departmentTypeId) {
            console.log("DISPATCHING GET_DEPARTMENT_TYPES_BY_ID", departmentTypeId);

            dispatch(getDepartmentDataById(departmentTypeId));
        }
    }, [isEditMode, departmentTypeId]);


    /* ===================== SET FORM VALUES ===================== */
    useEffect(() => {
        if (isEditMode && selected) {
            setValues({ name: selected.name });
        }
    }, [selected]);

    /* ===================== SUBMIT HANDLER ===================== */
    const handleSubmitDepartment = async () => {
        handleSubmit();
        if (!isValid) return;

        hasSubmittedRef.current = true;

        if (isEditMode) {
            await dispatch(updateDepartmentTypes(departmentTypeId, { name: values.name }));
            dispatch(getAllDepartmentTypes());
            navigate("/department-type");

        } else {
            await dispatch(createDepartmentTypes({ name: values.name }));
            dispatch(getAllDepartmentTypes());
            navigate("/department-type");

        }
    };

    /* ===================== UI ===================== */
    return (
        <div className="main-content p-5">
            <h1 style={{ color: colorMode === "light" ? "black" : "white" }}>{isEditMode ? "Edit" : "Add"} Department</h1>
            <div className="row">
                <div className="col-md-4 mt-4">
                    <Label
                        htmlFor="name"
                        className={`form-label mt-1 ${errors.name && touched.name ? "is-invalid" : ""
                            }`}
                        sx={{ color: colorMode === "light" ? "black" : "white" }}
                    >
                        Department Name*
                    </Label>
                    <Field
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Department Name"
                    />
                    <ErrorMessage name="name" component="div" className="text-danger" />
                </div>
            </div>
            <div className="row mt-5">
                <div className="col-md-4" />
                <div className="col-md-4">
                    <Button
                        type="button"
                        sx={{
                            border: `1px solid ${theme.colors?.primary}`,
                            background: "white",
                            color: theme.colors?.muted,
                            borderRadius: "12px",
                            padding: [2, 4],
                            width: "95%",
                        }}
                        onClick={() => navigate(-1)}
                    >
                        Cancel
                    </Button>
                </div>
                <div className="col-md-4">
                    <Button
                        sx={{
                            borderRadius: "12px",
                            padding: [2, 4],
                            width: "95%",
                        }}
                        type="submit"
                        onClick={handleSubmitDepartment}
                        disabled={isSubmitting || loading}
                    >
                        Submit
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default withFormikValidation(AddEditDepartmentMasterData);
